import script from "./kaojiang_drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./kaojiang_drawer.vue?vue&type=script&setup=true&lang=js"

import "./kaojiang_drawer.vue?vue&type=style&index=0&id=3039d2c0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3039d2c0"]])

export default __exports__